/* eslint-disable import/no-unresolved */
import CustomOTPModal from "src/shared/CustomOtpModal";
import useQuery from "src/utils/hooks/useQuery";
import { useMutation, useQuery as useQueryAPICall } from "react-query";
import { resendOtp, sendOtpLink, verifyOtp } from "src/services/VerifyCustomer";
import { useState } from "react";
import CustomBackDrop from "src/shared/CustomBackDrop";
import { useDispatch } from "react-redux";
import { setOtpVerificationDetails, setLeadId, setVerifyOtpLeadId } from "src/redux/Actions/common";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import StorageService from "src/utils/Storage/storageService";
import { EInsurerType } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import VerifyCustomerDetails from "../ReviewDetails";

interface Props {
  insurerType: EInsurerType;
}

function VerifyCustomerByOTP({ insurerType }: Props) {
  const query = useQuery();
  const id = query.get("id") as string;
  const [sendOTPId, setSendOTPId] = useState("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(true);
  const dispatch = useDispatch();
  const otpValue = useAppSelector((state) => state.otpVerificationDetails.otpValue);

  const { isLoading: isSendOtpLoading, isError } = useQueryAPICall(
    "sendOtp",
    () => sendOtpLink(id),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      enabled: otpValue.length < 1,
      onSuccess: (response) => {
        setSendOTPId(response.data?.id);
        dispatch(setOtpVerificationDetails({ otpVerificationId: response?.data?.id }));
        StorageService.setInLocalStorage("verificationToken", response?.data?.token);
      }
    }
  );
  const { mutate: resendOtpMutation, isLoading: isReSendOtpLoading } = useMutation(
    () => resendOtp(sendOTPId),
    {
      retry: false
    }
  );
  const handleResendOTP = () => {
    resendOtpMutation();
  };

  const { mutate: verifyOtpMutation } = useMutation(verifyOtp, {
    onSuccess: (res, req) => {
      const leadId = res?.data?.id || "";
      dispatch(setVerifyOtpLeadId({ leadId }));
      dispatch(setOtpVerificationDetails({ otpValue: req?.otp }));
      dispatch(setLeadId(leadId));
      setIsOtpModalOpen(false);
    },
    onError: () => {
      dispatch(setOtpVerificationDetails({ otpValue: "" }));
    }
  });

  const handleVerifyOTP = ({ id: verificationId, otp }: { id: string; otp: string }) => {
    verifyOtpMutation({ id: verificationId, otp });
  };

  if (isSendOtpLoading || isReSendOtpLoading) {
    return <CustomBackDrop open />;
  }

  if (isError) {
    return <div className="text-center mt-10 text-2xl font-bold text-hotShot">No Data Found</div>;
  }

  return (
    <>
      <CustomOTPModal
        modalHeading="Please enter the OTP sent on your registered mobile number"
        isModal={isOtpModalOpen}
        setIsOtpModalOpen={setIsOtpModalOpen}
        onResendClick={handleResendOTP}
        onVerify={handleVerifyOTP}
        onCancel={() => window.close()}
      />
      <VerifyCustomerDetails insurerType={insurerType} />
    </>
  );
}

export default VerifyCustomerByOTP;
